// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primery-gradient-btn {
  background-image: linear-gradient(to right, #ee855d, #da512d) !important;
}

.primery-gradient-btn:disabled {
  background-image: none !important;
  background-color: #9095a3 !important;
  color: #fff !important;
}

.action-btn {
  background-color: #9095a3 !important;
  color: #fff !important;
}

.white-spinner ::ng-deep circle {
  stroke: #ffffff !important;
}

.text-blue {
  color: #1c2c57;
  font-weight: 700;
  font-size: 14px;
}

.title {
  color: #1c2c57;
  font-family: Roboto;
  font-size: 17px;
  font-weight: 700;
}

.font-blue{
  color: #1c2c57 !important;
}

.font-normal {
  font-weight: 400;
}

.text-sm {
  font-size: 16px;
}

.card {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
}

::ng-deep .ant-switch-checked {
  background-color: #da512d !important;
}

.custom-gutter-16 > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

.button-container {
  border-radius: 100px !important;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/referral-qr/referral-qr.component.css"],"names":[],"mappings":"AAAA;EACE,wEAAwE;AAC1E;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,4qEAA4qE","sourcesContent":[".primery-gradient-btn {\n  background-image: linear-gradient(to right, #ee855d, #da512d) !important;\n}\n\n.primery-gradient-btn:disabled {\n  background-image: none !important;\n  background-color: #9095a3 !important;\n  color: #fff !important;\n}\n\n.action-btn {\n  background-color: #9095a3 !important;\n  color: #fff !important;\n}\n\n.white-spinner ::ng-deep circle {\n  stroke: #ffffff !important;\n}\n\n.text-blue {\n  color: #1c2c57;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.title {\n  color: #1c2c57;\n  font-family: Roboto;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.font-blue{\n  color: #1c2c57 !important;\n}\n\n.font-normal {\n  font-weight: 400;\n}\n\n.text-sm {\n  font-size: 16px;\n}\n\n.card {\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);\n}\n\n::ng-deep .ant-switch-checked {\n  background-color: #da512d !important;\n}\n\n.custom-gutter-16 > [class*=\"col-\"] {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.button-container {\n  border-radius: 100px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
